/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { FunctionComponent } from 'react';
import FederatedMFE from 'common/components/FederatedMFE';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useFeaturePerTerritoryConfig } from 'common/helpers/projectInitUtil';
import featureFlags from 'common/helpers/featureFlags';
import { injectReducerAsync } from '../../app/reduxStore';

import styles from './ProjectImportPage.module.scss';
import { getProject } from '../project/projectSlice';

const ProjectImport: FunctionComponent = () => {
  const { projectId }: { projectId: string } = useParams();
  const { name: projectName } = useSelector(getProject);

  const projectImportConfig = useFeaturePerTerritoryConfig('projectImport');
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const isProjectImportTerritoryAllowed = Boolean(projectImportConfig?.value);

  return (
    <div className={styles['project-import--wrapper']}>
      <FederatedMFE
        urlKey="REACT_APP_PROJECT_IMPORT_MFE_URL"
        scope="remoteapp"
        reducerModule="./ProjectImportReducer"
        componentModule="./ProjectImport"
        injectionReducerCb={injectReducerAsync}
        suspenseFallbackStyle=""
        props={{
          projectId,
          projectName,
          isProjectImportTerritoryAllowed,
          isContentTemplateSetEnabled: featureFlags.isContentTemplateSetEnabled,
          isGLTEnabled: featureFlags.isGLTEnabled,
        }}
      />
    </div>
  );
};

export default ProjectImport;
